import i18n from "i18next";
import { AavoDialog, AavoDialogProps } from "src/components/common/dialogs/AavoDialog.tsx";
import { AavoButton } from "src/components/common/buttons/AavoButton.tsx";

export interface MessageDialogProps extends Omit<AavoDialogProps, "actions"> {
	onClickOk: () => void;
}

export const MessageDialog = ({ onClickOk, size = "sm", ...other }: MessageDialogProps) => {
	return (
		<AavoDialog
			size={size}
			actions={<AavoButton onClick={onClickOk}>{i18n.t("ok")}</AavoButton>}
			{...other}
		/>
	);
};
